<template>
  <v-container fluid grid-list-lg>
    <v-row>
      <v-col cols="12" md="4" sm="12">
        <StudentCount />
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card
            outlined
            :class="{ 'elevation-5': hover }"
            style="transition: transform 0.3s"
            :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)' }"
            @click="$router.push({ path: '/parents/noInvoice' })"
          >
            <v-card-text>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-subtitle-2 grey--text text-uppercase">
                    Invoice Not Created
                  </div>
                  <div class="text-h5 font-weight-bold">
                    <div class="display-3 font-weight-light">
                      {{ Customer }}
                    </div>
                  </div>
                  <v-btn text small class="mt-2" color="primary"
                    >View List</v-btn
                  >
                </div>
                <v-img
                  max-width="80"
                  src="@/assets/AdminTools/invoice.png"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="4" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card
            outlined
            @click="$router.push({ path: '/parents/noSubscription' })"
            :class="{ 'elevation-10': hover }"
            style="transition: transform 0.3s"
            :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)' }"
          >
            <v-card-text>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-subtitle-2 grey--text text-uppercase">
                    Missing Subscriptions
                  </div>
                  <div class="text-h5 font-weight-bold">
                    <div class="display-3 font-weight-light">
                      {{ CustomerWithoutSub }}
                    </div>
                  </div>
                  <v-btn text small class="mt-2" color="primary"
                    >View List</v-btn
                  >
                </div>
                <v-img
                  max-width="80"
                  src="@/assets/AdminTools/subscribe.png"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card
            outlined
            :class="{ 'elevation-5': hover }"
            style="transition: transform 0.3s"
            :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)' }"
            @click="
              $router.push({
                path: '/parents/list',
                query: { ShowBalanceOnly: true },
              })
            "
          >
            <v-card-text>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-subtitle-2 grey--text text-uppercase">
                    Outstanding fee
                  </div>
                  <div class="text-h5 font-weight-bold">
                    <div class="font-weight-light" :class="{'display-3': !$vuetify.breakpoint.xsOnly, 'display-1': $vuetify.breakpoint.xsOnly}">
                      {{ CustomerOutstandingBal | currency }}
                    </div>
                  </div>
                  <v-btn text small class="mt-2" color="primary"
                    >View List</v-btn
                  >
                </div>
                <v-img max-width="80" src="@/assets/AdminTools/fee.png"></v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
      <v-col cols="12" md="6" sm="12">
        <v-hover v-slot="{ hover }">
          <v-card
            outlined
            :class="{ 'elevation-10': hover }"
            style="transition: transform 0.3s"
            :style="{ transform: hover ? 'scale(1.02)' : 'scale(1)' }"
            @click="
              $router.push({
                path: '/donors/list',
                query: { ShowBalanceOnly: true },
              })
            "
          >
            <v-card-text>
              <div class="d-flex justify-space-between align-center">
                <div>
                  <div class="text-subtitle-2 grey--text text-uppercase">
                    Outstanding Donors
                  </div>
                  <div class="text-h5 font-weight-bold">
                    <div class="font-weight-light" :class="{'display-3': !$vuetify.breakpoint.xsOnly, 'display-1': $vuetify.breakpoint.xsOnly}">
                      {{ DonorOutstandingBal | currency }}
                    </div>
                  </div>
                  <v-btn text small class="mt-2" color="primary"
                    >View List</v-btn
                  >
                </div>
                <v-img
                  max-width="80"
                  src="@/assets/AdminTools/donation.png"
                ></v-img>
              </div>
            </v-card-text>
          </v-card>
        </v-hover>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" md="6">
        <PendingApplication
          :classesList="classesList"
          :totalStudent="totalStudent"
        />
      </v-col>
      <v-col cols="12" md="6">
        <PendingComment
          :unCommentLeads="unCommentLeads"
          :unCommentCount="unCommentLeads.length"
        />
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import StudentCount from "@/modules/Student/components/Count.vue";

import RegisterStoreModule from "@/mixins/RegisterStoreModule";
import classService from "@/modules/Classes/service.js";
import leadService from "@/modules/Application/service.js";
import customerService from "@/modules/Customer/service.js";
import PendingApplication from "./components/PendingApplication.vue";
import PendingComment from "@/modules/Home/components/PendingComments.vue";
import donorService from "@/modules/Donors/service.js";
import { mapGetters } from "vuex";

export default {
  name: "home",
  mixins: [RegisterStoreModule],
  data() {
    return {
      classesList: [],
      unCommentLeads: [],
      Customer: 0,
      CustomerOutstandingBal: 0,
      DonorOutstandingBal: 0,
      CustomerWithoutSub: 0,
      isLoading: false,
      totalValue: 106416,
    };
  },
  components: {
    StudentCount,
    PendingApplication,
    PendingComment,
    // PendingOrder,
    // SaleCount,
    // TodayPayment,
    // InvoiceCount,
    // SignUpCount,
    // InvoiceBySalesRep,
  },
  created() {
    document.title = "taleem - Home";
    this.getClassInfo();
    this.getLeadsWithOutComment();
    this.getNoInvoiceCount();
    this.getCustomerOutstandingBalance();
    this.getDonorOutstandingBalance();
    this.getNoSubCount();
  },
  computed: {
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
    totalStudent() {
      let total = 0;
      this.classesList.map((row) => {
        total += row.totalStudentLeads;
      });
      return total;
    },
  },
  methods: {
    getNoInvoiceCount() {
      this.isLoading = true;
      let where = {
        start: this.$moment().startOf("month").toISOString(),
        end: this.$moment().endOf("month").toISOString(),
        limit: 1,
      };
      // if (this.CustomerId) {
      //   where.CustomerId = this.CustomerId;
      // }
      // if (this.ClassId) {
      //   where.ClassId = this.ClassId;
      // }
      console.log("where", where);
      return customerService.getAllNoInvoice(where).then((response) => {
        console.log("response", response);
        this.isLoading = false;
        this.Customer = response.count;
        this.itemsPerPage = this.Customer.length;
      });
    },
    getNoSubCount() {
      this.isLoading = true;
      return customerService.getAllNoSubscription().then((response) => {
        this.isLoading = false;
        this.CustomerWithoutSub = response.count;
      });
    },
    getCustomerOutstandingBalance() {
      customerService.getOutstandingBalance().then((response) => {
        this.CustomerOutstandingBal = response.data;

        this.isLoading = false;
      });
    },
    getDonorOutstandingBalance() {
      donorService.getOutstandingBalance().then((response) => {
        this.DonorOutstandingBal = response.data;

        this.isLoading = false;
      });
    },
    // openStudentList(item) {
    //   console.log("item", item);
    //   this.$router.push({
    //     path: "/applications/list",
    //     query: { ClassId: item.id, ClassName: item.name },
    //   });
    // },
    profile(lead) {
      this.$router.push({ path: `/applications/${lead.id}/profile` });
    },
    getClassInfo() {
      classService.getClassInfo().then((result) => {
        this.classesList = result.data;
      });
    },
    getLeadsWithOutComment() {
      leadService.leadsWithoutComment().then((result) => {
        // console.log("leadsWithoutComment", result);
        this.unCommentLeads = result.data;
      });
    },
  },
};
</script>
